export const constants = {
  bg: "#FFFFFF",
  bg2: "#40A7FF00",
  primary: "#2699FB",
  secondary: "#BCE0FD",
  third: "#7B7B7B",
  success: "#2BAC18",

  fontFamily: "Arial",
};